export default __webpack_public_path__ + "static/media/more_horiz.4527138e.svg";